import { bigQuery } from '@fiverr-private/obs';
import { getContext } from '@fiverr-private/fiverr_context';

export enum EventGroup {
    impression = 'user_impressions',
    action = 'user_action',
}

export interface BiEnrichment extends Record<string, unknown> {
    type?: string;
    actionType: 'page_view' | 'imp' | 'click';
    source?: string;
    element?: {
        text: string;
        type?: 'business' | 'mp' | 'button';
        name?: string;
    };
}

export const sendBqEvent = (
    group: 'user_impressions' | 'user_action' | 'page_view',
    { type, element, source, actionType, ...rest }: BiEnrichment
) => {
    const { userId, userGuid, pageCtxId } = getContext();

    const payload = {
        type,
        event_source: source || 'skill_page_perseus',
        entity: 'client',
        uid: userGuid,
        user_id: userId,
        user: {
            id: userId,
            uid: userGuid,
        },
        group,
        sub_group: 'fiverr_pro',
        action: {
            type: actionType,
        },
        feature: {
            name: 'fiverr_pro',
        },
        page: {
            ctx_id: pageCtxId,
            name: 'skill_page',
            element,
            component: {
                name: 'skill_page',
            },
        },
        out_of_session: !!userId,
        ...rest,
    };

    bigQuery.send(payload);
};
